import React, { useEffect, useState } from 'react';
import { v2_categories } from '../../../actions/v2/masterData';
import Select from 'react-select';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';

const SearchBar = ({ onSearch, onReset, projectId, encodedData }) => {
    const [filterData, setFilterData] = useState({
        keyword: { name: 'keyword', value: '' },
        categoryId: { name: 'categoryId', value: '', options: [] },
        tag: {
            name: 'tag',
            value: [],
            options: [
                { label: 'Opened', value: 'Opened' },
                { label: 'Closed', value: 'Closed' },
                { label: 'Rejected', value: 'Rejected' }
            ]
        }
    });

    useEffect(() => {
        v2_categories().then((res) => {
            if (res.status) {
                setFilterData((prev) => ({
                    ...prev,
                    categoryId: {
                        ...prev.categoryId,
                        options: res.result || []
                    }
                }));
            }
        });
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilterData((prev) => ({
            ...prev,
            [name]: { ...prev[name], value },
        }));
    };
    useEffect(() => {
        handleSearch()
    }, [filterData.keyword.value, filterData.categoryId.value, filterData.tag.value])

    const handleSearch = () => {
        const modelPayload = {
            keyword: filterData.keyword.value?.trim() || '',
            categoryId: filterData.categoryId.value || '',
            status: filterData.tag.value.map((opt) => opt.value),
        };
        const encodedPayload = btoa(JSON.stringify(modelPayload));
        if (onSearch) onSearch(encodedPayload);
    };

    const handleMultiSelectChange = (selectedOptions) => {
        setFilterData((prev) => ({
            ...prev,
            tag: {
                ...prev.tag,
                value: selectedOptions || [],
            },
        }));
    };

    const handleReset = () => {
        const resetData = {
            keyword: { name: 'keyword', value: '' },
            categoryId: { name: 'categoryId', value: '', options: filterData.categoryId.options },
            tag: { name: 'tag', value: [], options: filterData.tag.options },
        };
        setFilterData(resetData);
        if (onReset) {
            onReset(resetData);
        }
    };

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card card-mrg">
                    <div className="card-body card-body-search">
                        <form
                            className="row gy-12 gx-12 align-items-center"
                            onSubmit={handleSearch}
                        >
                            <div className="row">
                                <div className="form-group col-md-3">
                                    <input
                                        type="text"
                                        name={filterData.keyword.name}
                                        value={filterData.keyword.value}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter Claim Subject, ID & Keywords..."
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <select
                                        name={filterData.categoryId.name}
                                        value={filterData.categoryId.value}
                                        onChange={handleChange}
                                        className="form-control"
                                    >
                                        <option value="">All Categories</option>
                                        {filterData.categoryId.options.map((item) => (
                                            <option key={item.ID} value={item.ID}>
                                                {item.CATEGORY_NAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-md-4">
                                    <Select
                                        isMulti
                                        name="tag"
                                        value={filterData.tag.value}
                                        options={filterData.tag.options}
                                        onChange={handleMultiSelectChange}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="All Status"
                                    />
                                </div>
                                <div className="form-group col-md-2">
                                    <Link
                                        className="btn btn-primary"
                                        to={{
                                            pathname: constant.Authedcomponent.createNewGuarantyClaim.url,
                                            state: {
                                                data: encodedData,
                                            },
                                        }}
                                        style={{ backgroundColor: '#29577b', borderColor: '#29577b' }}
                                    >
                                        <i className="bx bx-plus align-middle" /> Add New Claim
                                    </Link>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchBar;
